<wu-layout>
  <router-outlet></router-outlet>
</wu-layout>

<!-- Accessibility: aria-live region for screen reader announcements (WCAG 4.1.3) -->
<div
  id="a11y-announcer"
  aria-live="polite"
  aria-atomic="true"
  class="sr-only"
></div>
